
import { useState, memo, useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Pricing = memo(() => {
  const [activeTab, setActiveTab] = useState("exterior");
  
  const exteriorWashServices = useMemo(() => [
    { name: 'Mycie ,,Basic"', price: '79 zł brutto', description: 'Pianowanie, mycie ręczne, felgi, szyby' },
    { name: 'Mycie ,,Premium"', price: '119 zł brutto', description: 'Pianowanie, mycie ręczne, felgi, szyby + wosk na mokro + dressingi opon' },
    { name: 'Mycie detailingowe', price: '249 zł brutto', description: 'Pianowanie, dekontaminacja, glinkowanie, wosk na mokro + dressingi opon' }
  ], []);
  
  const interiorDetailingServices = useMemo(() => [
    { name: 'Detailing wnętrza ,,Basic"', price: '99 zł brutto', description: 'Odkurzanie, czyszczenie plastików, szyb' },
    { name: 'Detailing wnętrza „Plus"', price: '249 zł brutto', description: 'Odkurzanie, czyszczenie plastików, szyb + dressingi + wnęki' },
    { name: 'Detailing wnętrza „Ultra"', price: '499 zł brutto', description: 'Odkurzanie, plastiki, szyby, dressingi, wnęki + pranie tapicerki/czyszczenie skór + podsufitka' }
  ], []);
  
  const upholsteryCleaning = useMemo(() => [
    { name: 'Pranie foteli przednich + tylnych', price: '239 zł brutto', description: 'Ekstrakcyjne, z neutralizacją zapachu' },
    { name: 'Pranie całego wnętrza', price: '399 zł brutto', description: 'Fotele, podłoga, boczki, podsufitka' },
    { name: 'Czyszczenie tapicerki skórzanej', price: '249 zł brutto', description: 'Mycie, szczotkowanie, konserwacja' }
  ], []);
  
  const packages = useMemo(() => [
    { name: 'Pakiet „Premium"', price: '499 zł brutto', description: 'Mycie Premium + Detailing wnętrza „Plus" + Pranie foteli' },
    { name: 'Pakiet „Detailing Kompletny"', price: '699 zł brutto', description: 'Mycie detailingowe + Detailing wnętrza „Ultra"' },
    { name: 'Pakiet „Express"', price: '159 zł brutto', description: 'Mycie ,,Basic" + Detailing wnętrza ,,Basic"' }
  ], []);
  
  const additionalServices = useMemo(() => [
    { name: 'Ozonowanie wnętrza', price: '79 zł brutto', description: 'Likwidacja zapachów, bakterii i wirusów' },
    { name: 'Impregnacja tapicerki tekstylnej', price: '149 zł brutto', description: 'Zabezpieczenie przed wilgocią i zabrudzeniami' },
    { name: 'Powłoka hydrofobowa na szyby', price: '99 zł brutto', description: 'Niewidzialna wycieraczka' },
    { name: 'Dressingi plastików zewnętrznych', price: '79 zł brutto', description: 'Odświeżenie i zabezpieczenie tworzyw' }
  ], []);

  const travelServices = useMemo(() => [
    { name: 'Dojazd w promieniu 5km', price: 'Bezpłatny', description: 'Bezpłatny dojazd w promieniu 5km od siedziby firmy (ul. Bluszczowa)' },
    { name: 'Dojazd 5-15km', price: '19 zł', description: 'Dojazd w promieniu 5-15km od siedziby firmy' },
    { name: 'Dojazd 15-30km', price: '39 zł', description: 'Dojazd w promieniu 15-30km od siedziby firmy' },
    { name: 'Dojazd powyżej 30km', price: 'Do uzgodnienia', description: 'Koszt dojazdu ustalany indywidualnie' }
  ], []);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const renderTabContent = useMemo(() => {
    const renderServices = (services: Array<{name: string, price: string, description: string}>, gridCols: string = "md:grid-cols-3") => (
      <div className={`grid grid-cols-1 ${gridCols} gap-4 md:gap-6`}>
        {services.map((service) => (
          <div key={service.name}>
            <Card className="bg-black border-white/20 shadow-md hover:shadow-lg transition-all duration-300 h-full">
              <CardHeader className="pb-2 p-4 md:p-6">
                <CardTitle className="text-base md:text-xl flex flex-col">
                  <span className="mb-2 text-white text-center">{service.name}</span>
                  <span className="text-garage-blue font-bold text-center">{service.price}</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="p-4 md:p-6 pt-0">
                <p className="text-gray-300 text-sm md:text-base text-center">{service.description}</p>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    );

    switch (activeTab) {
      case 'exterior':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Mycie zewnętrzne</h3>
            {renderServices(exteriorWashServices)}
          </div>
        );
      case 'interior':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Detailing wnętrza</h3>
            {renderServices(interiorDetailingServices)}
          </div>
        );
      case 'upholstery':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Pranie tapicerki</h3>
            {renderServices(upholsteryCleaning)}
          </div>
        );
      case 'packages':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Pakiety usług</h3>
            {renderServices(packages)}
          </div>
        );
      case 'additional':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Usługi dodatkowe</h3>
            {renderServices(additionalServices, "md:grid-cols-2")}
          </div>
        );
      case 'travel':
        return (
          <div className="pt-4 md:pt-6">
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 text-center">Dojazd</h3>
            {renderServices(travelServices, "md:grid-cols-2")}
          </div>
        );
      default:
        return null;
    }
  }, [activeTab, exteriorWashServices, interiorDetailingServices, upholsteryCleaning, packages, additionalServices, travelServices]);

  return (
    <section id="pricing" className="bg-garage-darker py-12 md:py-20">
      <div className="container mx-auto">
        <h2 
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-8 md:mb-12 pb-4 text-white"
        >
          Cennik usług
        </h2>
        
        <div className="mb-6 md:mb-8 bg-black border border-white/20 rounded-lg p-3 md:p-4 shadow-md pricing-tabs">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-2 md:gap-3">
            <button 
              onClick={() => handleTabChange('exterior')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'exterior' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Mycie zewnętrzne
            </button>
            <button 
              onClick={() => handleTabChange('interior')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'interior' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Detailing wnętrza
            </button>
            <button 
              onClick={() => handleTabChange('upholstery')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'upholstery' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Pranie tapicerki
            </button>
            <button 
              onClick={() => handleTabChange('packages')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'packages' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Pakiety
            </button>
            <button 
              onClick={() => handleTabChange('additional')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'additional' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Usługi dodatkowe
            </button>
            <button 
              onClick={() => handleTabChange('travel')}
              className={`py-2 md:py-3 px-2 md:px-4 rounded-md transition-colors pricing-tab-button text-xs md:text-sm font-medium touch-manipulation ${
                activeTab === 'travel' 
                  ? 'bg-garage-blue text-white shadow-md' 
                  : 'bg-black text-white/90 hover:bg-white/10 border border-white/20'
              }`}
            >
              Dojazd
            </button>
          </div>
        </div>
        
        <div className="pricing-content-wrapper">
          <div className="pricing-content">
            {renderTabContent}
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="/rezerwacje"
            className="inline-block bg-garage-blue hover:bg-blue-700 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Umów wizytę online
          </a>
        </div>
      </div>
    </section>
  );
});

Pricing.displayName = 'Pricing';

export default Pricing;
